import React from 'react'
import styled from 'styled-components'

import { Button } from '@mote/ui'
import { ChromeIcon } from '@mote/assets/icons'

import { ReactComponent as BusinessCardSVG } from './assets/DemoBusinessCard.svg'
import { Content } from '../../../../layouts/shared/content'
import { CWS_URL } from '@mote/helpers/constants'
import { Reviews } from './Reviews'
import { useTrackMutation } from '@mote/api'

export const HeroSection = () => {
  const { mutate: track } = useTrackMutation()

  function handleAddToChromeClick() {
    track({
      variables: {
        event: 'Install Extension Clicked',
        referrer_user_id: window.localStorage.getItem('mote_referrer_user_id')
      }
    })
    window.open(CWS_URL, '_new')
  }

  return (
    <Root>
      <Content>
        <Container>
          <Main>
            <Title>Fast, human, accessible.</Title>
            <SubTitle>
              Increase workplace productivity, connection and accessibility with
              Mote voice messaging.
            </SubTitle>
            <Button
              text='Add to Chrome'
              iconPosition='left'
              icon={<ChromeIcon />}
              onClick={handleAddToChromeClick}
            />
            <Reviews />
          </Main>
          <BusinessCardSVG />
        </Container>
      </Content>
    </Root>
  )
}

const Root = styled.div`
  padding: 128px 0px;

  @media (max-width: 991px) {
    padding: 0;
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 991px) {
    flex-wrap: wrap;
  }
`

const Main = styled.section`
  flex: 0 0 430px;
  margin-right: 41px;

  @media (max-width: 991px) {
    // order: 1;
    padding-bottom: 48px;
  }
  @media (max-width: 639px) {
    padding-bottom: 40px;
    flex: 0 0 330px;
  }
`
const Title = styled.h1`
  font-style: normal;
  font-weight: bold;
  font-size: 58px;
  line-height: 110%;
  letter-spacing: -0.05em;
  color: #232323;
  margin-bottom: 16px;
`
const SubTitle = styled.h4`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 150%;
  color: #232323;
  margin-bottom: 32px;
`
